"use client";
import { jsxs as l, jsx as e, Fragment as b } from "react/jsx-runtime";
import { useState as L, useId as C, useRef as x, useEffect as E } from "react";
import { cn as r } from "../utils/cn.js";
import { N3wthProvider as Q } from "../theme/N3wthProvider.js";
import { n3wthTheme as V } from "../theme/n3wthTheme.js";
import { useRouteScrollReset as Y } from "../hooks/useRouteScrollReset.js";
import { ReadingOutline as _ } from "./ReadingOutline.js";
import { Heading as M } from "../node_modules/@astryxdesign/core/dist/Heading/Heading.js";
import { Text as T } from "../node_modules/@astryxdesign/core/dist/Text/Text.js";
function H({ as: t = "div", className: n, ...i }) {
  return /* @__PURE__ */ e(t, { className: r("n3wth-site-container", n), ...i });
}
function D({ className: t, ...n }) {
  return /* @__PURE__ */ e("section", { className: r("n3wth-site-section", t), ...n });
}
function q({ className: t, ...n }) {
  return /* @__PURE__ */ e("nav", { className: r("n3wth-site-section-links", t), ...n });
}
const O = { page: 1, section: 2, item: 3 };
function y({ variant: t = "section", level: n, className: i, children: a, ...s }) {
  return /* @__PURE__ */ e(M, { level: n ?? O[t], className: r("n3wth-site-heading", `n3wth-site-heading--${t}`, i), ...s, children: a });
}
function R({ variant: t = "body", as: n = "p", className: i, children: a, ...s }) {
  return /* @__PURE__ */ e(T, { as: n, type: t === "lede" ? "body" : t, display: n === "span" ? "inline" : "block", className: r("n3wth-site-text", `n3wth-site-text--${t}`, i), ...s, children: a });
}
function B({ title: t, level: n = 2, className: i, children: a, ...s }) {
  return /* @__PURE__ */ l("div", { className: r("n3wth-site-doc-section", i), ...s, children: [
    t != null ? /* @__PURE__ */ e(y, { variant: "section", level: n, children: t }) : null,
    a
  ] });
}
function G({ items: t, className: n, ...i }) {
  return /* @__PURE__ */ e("ul", { className: r("n3wth-site-doc-list", n), ...i, children: t.map((a, s) => /* @__PURE__ */ e("li", { children: a }, s)) });
}
function W({ title: t, level: n = 1, description: i, actions: a, aside: s, align: h = "start", className: u, ...m }) {
  return /* @__PURE__ */ l("header", { className: r("n3wth-site-page-header", s != null && "n3wth-site-page-header--split", h === "center" && "n3wth-site-page-header--center", u), ...m, children: [
    /* @__PURE__ */ l("div", { className: "n3wth-site-page-header-copy", children: [
      /* @__PURE__ */ e(y, { variant: n === 1 ? "page" : "section", level: n, children: t }),
      i != null && /* @__PURE__ */ e(R, { className: "n3wth-site-description", children: i }),
      a != null && /* @__PURE__ */ e("div", { className: "n3wth-site-actions", children: a })
    ] }),
    s != null && /* @__PURE__ */ e("div", { className: "n3wth-site-page-header-aside", children: s })
  ] });
}
function z({ brand: t, links: n, actions: i, navigationLabel: a = "Primary", navigationId: s, menuLabel: h = "Open menu", className: u, ...m }) {
  const [d, o] = L(!1), S = C(), w = s ?? `site-navigation-${S}`, v = x(null), f = x(null);
  return E(() => {
    if (!d) return;
    f.current?.querySelector(".n3wth-site-navigation-links a")?.focus();
    const c = window.matchMedia("(min-width: 768px)"), g = () => {
      c.matches && o(!1);
    }, N = (p) => {
      f.current?.contains(p.target) || o(!1);
    }, k = (p) => {
      p.key === "Escape" && (o(!1), v.current?.focus());
    };
    return document.addEventListener("pointerdown", N), document.addEventListener("keydown", k), c.addEventListener("change", g), () => {
      document.removeEventListener("pointerdown", N), document.removeEventListener("keydown", k), c.removeEventListener("change", g);
    };
  }, [d]), /* @__PURE__ */ e("header", { ...m, ref: f, className: r("n3wth-site-navigation", u), children: /* @__PURE__ */ l("div", { className: "n3wth-site-navigation-island", "data-nosnippet": !0, children: [
    /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-brand", onClick: () => o(!1), children: t }),
    /* @__PURE__ */ e("nav", { id: w, "aria-label": a, className: "n3wth-site-navigation-links", "data-open": d, onClick: (c) => {
      c.target.closest("a") && o(!1);
    }, children: n }),
    /* @__PURE__ */ e("div", { className: "n3wth-site-navigation-actions", onClick: () => o(!1), children: i }),
    /* @__PURE__ */ e("button", { ref: v, type: "button", className: "n3wth-site-navigation-toggle", "aria-label": d ? "Close menu" : h, "aria-controls": w, "aria-expanded": d, onClick: () => o((c) => !c), children: /* @__PURE__ */ e("svg", { width: "18", height: "18", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", "aria-hidden": "true", children: d ? /* @__PURE__ */ e("path", { d: "m6 6 12 12M6 18 18 6" }) : /* @__PURE__ */ e("path", { d: "M4 6h16M4 12h16M4 18h16" }) }) })
  ] }) });
}
function A({ brand: t = /* @__PURE__ */ e("a", { href: "https://n3wth.com", children: "Oliver Newth" }), links: n, sourceHref: i = "https://github.com/n3wth/n3wth", legalLinks: a, children: s, className: h, ...u }) {
  const m = n ?? /* @__PURE__ */ l(b, { children: [
    /* @__PURE__ */ e("a", { href: "https://n3wth.com/library", children: "Library" }),
    /* @__PURE__ */ e("a", { href: "https://n3wth.com/contact", children: "Contact" }),
    /* @__PURE__ */ e("a", { href: i, children: "GitHub" }),
    a
  ] });
  return /* @__PURE__ */ e("footer", { ...u, className: r("n3wth-site-footer", h), children: /* @__PURE__ */ l(H, { "data-nosnippet": !0, children: [
    /* @__PURE__ */ l("div", { className: "n3wth-site-footer-row", children: [
      t != null && /* @__PURE__ */ e("div", { className: "n3wth-site-footer-brand", children: t }),
      /* @__PURE__ */ e("nav", { "aria-label": "Footer", className: "n3wth-site-footer-links", children: m })
    ] }),
    s != null && /* @__PURE__ */ e("div", { className: "n3wth-site-footer-meta", children: s })
  ] }) });
}
export {
  Q as N3wthProvider,
  W as PageHeader,
  _ as ReadingOutline,
  H as SiteContainer,
  G as SiteDocList,
  B as SiteDocSection,
  A as SiteFooter,
  y as SiteHeading,
  z as SiteNavigation,
  D as SiteSection,
  q as SiteSectionLinks,
  R as SiteText,
  V as n3wthTheme,
  Y as useRouteScrollReset
};
//# sourceMappingURL=index.js.map
